<template>
  <div class="gmf-compact-post">
    <div class="gmf-compact-post-identity">
      <Avatar :customer="post.author"/>

      <div class="gmf-compact-post-poster">
        <CustomerName :customer="post.author" />
        <div v-if="post.author.flags.includes('is_employee') && state.merchantConfig.widgets.showEmployeeTitle">
          <span class="gmf-customer-title" v-text="t('comments.employee_title')"></span>
        </div>
        <CustomerLevelRow :customer="post.author" v-else />
      </div>
    </div>

    <div class="gmf-compact-post-body">
      <CommentText class="gmf-comment-text" :value="text"></CommentText>
    </div>

    <div class="gmf-compact-post-show-more">
      <button class="gmf-btn gmf-btn-sm gmf-btn-primary"
        @click="openSocialModal({ displayHeader: true, scrollToCommentId: post.id, })">{{
        t('widgets.pinned_post.show_more') }}</button>
    </div>
  </div>
</template>

<style>
.gmf-compact-post {
  max-width: 500px;
  padding: var(--gmf-p-3) var(--gmf-p-4);
  background: var(--gmf-col-white);
  border-radius: var(--gmf-rounding);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1;
}

.gmf-compact-post-identity {
  display: flex;
  align-items: center;
}

.gmf-compact-post .gmf-avatar {
  margin-right: var(--gmf-p-3);
  position: relative;
  width: 48px;
  height: 48px;
  line-height: 0;
}

.gmf-compact-post-body {
  margin-top: var(--gmf-p-2);
  margin-bottom: var(--gmf-p-3);
  overflow: hidden;
  white-space: pre;
  text-align: left;
}

.gmf-compact-post-poster {
  flex-grow: 1;

  text-align: left;
}

.gmf-compact-post-poster-name.gmf-subheader.gmf-link-disabled {
  color: var(--gmf-col-darkgray);
}

.gmf-compact-post-show-more {
  text-align: center;
  flex-shrink: 0;
}

.gmf-compact-post .gmf-level-row {
  margin-top: 2px;
}
</style>

<script>
import Avatar from '@/components/Avatar';
import CustomerName from '@/components/CustomerName';
import CommentText from '@/components/Comment/CommentText';
import openSocialModal from '@/widgets/SocialFeed/openSocialModal';
import CustomerLevelRow from '@/components/CustomerLevelRow.vue';

import state from '@/state';

export default {
  components: {
    Avatar,
    CustomerName,
    CommentText,
    CustomerLevelRow
  },

  data: () => ({
    state,
    translate: false,
  }),

  props: {
    post: {
      type: Object,
      required: true,
    }
  },  
  computed: {
    text() {
      if (this.post && this.post?.translation && this.translate) {
        return this.post.translation.text;
      }

      return this.post.content.text;
    },
  },

  methods: {
    openSocialModal,
    t: state.t,
  },

  mounted() {
    this.translate = this.state.merchantConfig.widgets.translations.mode === 'autoTranslateAndOriginalButton'
  }
}
</script>